export const transformDateToSend = (date) => {
  if (!date) return null;
  const triades = date.split('.');

  if (triades.length !== 3) return null;

  return triades.reverse().join('-');
};

export const transformDateView = (date) => {
  if (!date) return null;

  return date.split(' ')[0].split('-').reverse().join('.');
};

export default transformDateToSend;
